var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        { staticClass: "d-flex align-center" },
        [
          _c(
            "v-tooltip",
            {
              attrs: { bottom: "", disabled: !_vm.isDisabled },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "div",
                          _vm._g(_vm._b({}, "div", attrs, false), on),
                          [
                            _c(
                              "v-btn-toggle",
                              {
                                attrs: {
                                  value: _vm.viewMode,
                                  mandatory: "",
                                  dense: "",
                                  color: "primary",
                                  disabled: _vm.isDisabled,
                                },
                                on: { change: _vm.onChange },
                              },
                              [
                                _c(
                                  "v-btn",
                                  { attrs: { small: "", value: "AD_GROUP" } },
                                  [_vm._v("Ad Group")]
                                ),
                                _c(
                                  "v-btn",
                                  { attrs: { small: "", value: "STORE" } },
                                  [_vm._v("Store")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                1871505929
              ),
            },
            [
              _c("span", [
                _vm._v(
                  "Finish editing the current batch before switching views."
                ),
              ]),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }